import React, { useEffect, useState } from "react";
import cn from "classnames";
import style from "../common.module.scss";
import { Order } from "../../../../services";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { toast } from "react-toastify";
import { acceptstatus, ORDER_STATUSES_DATA, rejectstatus } from "../../../../mock";
import {t} from "i18next";

const OrderDecision = ({ item, onUpdateData, fetchOrderData }) => {
  const [isLoading, setLoading] = useState(false);

  const handleDecisionOrder = (decision) => {
    setLoading(true);

    Order.updateStatus(item.id, decision)
      .then(() => {
        setLoading(false);
        if (decision === "published") {
          toast.success("Заказ успешно принято!");
        } else {
          toast.success("Цена успешно отклонен");
        }
        fetchOrderData();
        onUpdateData();
      })
      .catch((error) => {
        setLoading(false);
        console.error("Ошибка при отправке status:", error);
        toast.error("Произошла ошибка, попробуйте позже");
      });
  };

  const updateStatusUnloading = () => {
    setLoading(true);

    const status = acceptstatus(item.status);
    Order.updateStatus(item.id, status)
      .then(() => {
        setLoading(false);
        if (status === "completed") {
          toast.success("Принято");
        } else {
          toast.success("Отклонен");
        }
        fetchOrderData();
        onUpdateData();
      })
      .catch((error) => {
        setLoading(false);
        console.error("Ошибка при отправке status:", error);
        toast.error("Произошла ошибка, попробуйте позже");
      });
  };

  const rejectConfirm = () => {
    setLoading(true);

    const status = rejectstatus(item.status);
    Order.updateStatus(item.id, status)
      .then((response) => {
        setLoading(false);
        toast.success("Разгрузка отклонено");
        fetchOrderData();
        onUpdateData();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const renderStatus = () => {
    if (item.status === "assigned") {
      return (
        <div className={cn(style.cargo_wrapper)}>
          <div className={cn(style.cargo_title, style.orders_title)}>
              {t('acceptOrDecline')}
          </div>
          <div style={{ display: "flex", gap: "16px", width: "100%" }}>
            <CustomButton
              text={t('partnersTable.button.accept')}
              style={{ flex: "1" }}
              onClick={() => handleDecisionOrder("published")}
              isLoading={isLoading}
            />
            <CustomButton
              text={t('decline')}
              style={{ flex: "1" }}
              onClick={() => handleDecisionOrder("expeditorrejected")}
              isLoading={isLoading}
              isWhite
            />
          </div>
        </div>
      );
    } else if (item.status === "unloadingcargomoderation") {
      return (
        <div className={cn(style.cargo_wrapper)}>
          <div className={cn(style.cargo_title, style.orders_title)}>
              { t ("mockData.orderStatusLabels.unloadingcargomoderation")}
          </div>
          <div style={{ display: "flex", gap: "16px", width: "100%" }}>
            <CustomButton
              text={t('driversCreate.button.confirm')}
              style={{ flex: "1" }}
              onClick={updateStatusUnloading}
              isLoading={isLoading}
            />
            <CustomButton
              text={t('decline')}
              style={{ flex: "1" }}
              onClick={rejectConfirm}
              isLoading={isLoading}
              isWhite
            />
          </div>
        </div>
      );
    } else {
      return (
        null
      );
    }
    // } else {
    //   return (
    //     <>
    //       <div className={cn(style.cargo_title, style.orders_title)}>
    //         Статус заказа: {ORDER_STATUSES_DATA[item.status].title}
    //       </div>
    //     </>
    //   );
    // }
  };

  return renderStatus();
};

export default OrderDecision;
